import { Environment, type EnvironmentConfig } from './environment.types';

// Hostnames
const CLOUDFLARE_DEV_HOSTNAME = 'dev-praxisbyemergn.pages.dev';
const CLOUDFLARE_PROD_HOSTNAME = 'praxisbyemergn.pages.dev';
const APP_HOSTNAME = 'praxisbyemergn.com';

export const getEnvironmentConfig = (): EnvironmentConfig => {
  const hostname =
    typeof window !== 'undefined' ? window.location.hostname : '';

  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';

  const getEnvironment = (): Environment => {
    if (isLocalhost) {
      return Environment.Localhost;
    }

    if (hostname === CLOUDFLARE_DEV_HOSTNAME) {
      return Environment.Dev;
    }

    if (
      hostname === APP_HOSTNAME ||
      hostname.endsWith(`.${APP_HOSTNAME}`) ||
      hostname === CLOUDFLARE_PROD_HOSTNAME
    ) {
      return Environment.Production;
    }

    return Environment.Dev;
  };

  const envSupabaseUrl = import.meta.env.VITE_SUPABASE_URL;
  const envSupabasePublishableKey = import.meta.env
    .VITE_SUPABASE_PUBLISHABLE_KEY;
  const envClerkPublishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

  const environment = getEnvironment();

  return {
    environment,
    isLocalhost,
    isDev: environment === Environment.Dev,
    isQa: environment === Environment.QA,
    isStage: environment === Environment.Stage,
    isProduction: environment === Environment.Production,
    supabaseUrl: envSupabaseUrl,
    supabasePublishableKey: envSupabasePublishableKey,
    clerkPublishableKey: envClerkPublishableKey,
  };
};

export const buildEdgeFunctionUrl = (
  functionName: string,
  path: string = ''
): string => {
  const config = getEnvironmentConfig();
  return `${config.supabaseUrl}/functions/v1/${functionName}${path}`;
};

if (import.meta.env.DEV && !import.meta.env.VITEST) {
  console.log('Environment Config:', getEnvironmentConfig());
}
